import request from '@/utils/request'
//获取图形验证码
export const getCaptcha = () => {
  return request.get('/code')
}
//  获取验证吗
export const getSmsCode = (data) => {
  return request.post('/sms', data)
}
// 忘记密码
export const forgetPassword = (data) => {
  return request.post('/api/user/forget/password', data)
}

// 检查单位名称是否存在
export const checkCompany = (data) => {
  return request.post('/api/user/check/company', data)
}
// 检检查统一社会验证码名称是否存在
export const checkIdCard = (data) => {
  return request.post('/api/user/check/id', data)
}
// 检查统一社会验证码名称是否存在
export const checkUcc = (data) => {
  return request.post('/api/user/check/ucc', data)
}
// 获取所有注册角色
export const getUserRoles = () => {
  return request.get('/api/user/roles')
}
// 注册
export const register = (data) => {
  return request.post('/api/user/register', data)
}
//账号密码登录
export const loginByPassword = (data) => {
  return request.post('/api/user/login', data)
}
//uuid登录
export const loginByUuid = (data) => {
  return request.post('/api/user/uuid/login', data)
}




//短信登录(暂时没有使用)
export const loginBySms = (data) => {
  return request.post('/api/user/smsLogin', data)
}
//发送短信验证码(暂时没有使用)
export const sendSmsCode = (data) => {
  return request.post('/api/user/sendSmsCode', data)
}
//获取用户基本信息
export const getUserInfo = () => {
  return request.get('/api/user/info')
}
//用户绑定 ca
export const bindCa = (data) => {
  return request.post('/api/ca/bind', data)
}

//新增企业/组织信息
export const addOrganization = (data) => {
  return request.post('/api/user/organization/add', data)
}

//查询企业/组织信息
export const getOrganizationInfo = () => {
  return request.get('/api/user/organization/info')
}

//修改企业/组织信息
export const updateOrganization = (data) => {
  return request.post('/api/user/organization/update', data)
}
